import { TEMAS } from "../pages/EventoPublico/templates";
import { getRsvpCssVars, getRsvpTheme } from "../utils/rsvpTheme";
import RsvpClosedState from "./RsvpClosedState";

const label = { display: "block", marginBottom: 6, fontWeight: 600, color: "inherit", fontSize: 14 };
const input = {
  width: "100%", padding: "10px 12px", border: "2px solid #ddd", borderRadius: 8,
  fontSize: 15, background: "white", boxSizing: "border-box", fontFamily: "inherit",
  outline: "none", color: "#333",
};
const mockGuests = [
  { id: 1, nome: "Maria Clara" },
  { id: 2, nome: "Pedro Henrique" },
];

export default function MockRsvpForm({
  templateId = "original",
  layoutConfig = null,
  previewMode = "form",
  closedDeadline = "2026-04-23T22:00:00",
}) {
  const temaBase = TEMAS[templateId] || TEMAS.original;
  const tema = getRsvpTheme(temaBase, layoutConfig);
  const peopleTheme = tema.people ?? {};
  const messageTheme = tema.message ?? {};

  if (previewMode === "closed") {
    return (
      <div style={{ fontFamily: "'Poppins', sans-serif", ...getRsvpCssVars(tema), color: tema.formTextColor ?? "inherit" }}>
        <RsvpClosedState theme={tema} deadline={closedDeadline} />
      </div>
    );
  }

  if (previewMode === "invite") {
    return (
      <div style={{ fontFamily: "'Poppins', sans-serif", ...getRsvpCssVars(tema), color: tema.formTextColor ?? "inherit" }}>
        <div style={{
          background: peopleTheme.sectionBg ?? tema.sectionBg,
          borderRadius: 15,
          padding: 20,
          marginBottom: 20,
          color: peopleTheme.textColor ?? tema.labelColor,
          fontFamily: peopleTheme.fontFamily ?? undefined,
        }}>
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            marginBottom: 16,
          }}>
            <span style={{
              ...tema.titulo,
              color: peopleTheme.titleColor ?? tema.titulo?.color,
              fontFamily: peopleTheme.fontFamily ?? tema.titulo?.fontFamily,
              fontWeight: 600,
              fontSize: "1.1em",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              lineHeight: 1.2,
            }}>
              <span style={{ display: "inline-flex", alignItems: "center", lineHeight: 1 }} aria-hidden="true">👥</span>
              <span>Confirmar Presenças</span>
            </span>
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 8 }}>
              <button type="button" disabled style={mockShortcutButton("#ecfdf5", "#047857")}>✓ Todos vão</button>
              <button type="button" disabled style={mockShortcutButton("#fff1f2", "#be123c")}>× Todos não vão</button>
            </div>
          </div>

          {mockGuests.map((guest, index) => (
            <div key={guest.id} style={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr) auto",
              alignItems: "center",
              gap: 14,
              borderRadius: 14,
              padding: "14px 16px",
              marginBottom: 10,
              background: peopleTheme.itemBg ?? tema.itemBg,
              boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
            }}>
              <div style={{ minWidth: 0, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 7 }}>
                <span style={{
                  minWidth: 0,
                  color: peopleTheme.textColor ?? tema.labelColor,
                  fontWeight: 700,
                  overflowWrap: "anywhere",
                }}>
                  {guest.nome}
                </span>
                <span style={{
                  borderRadius: 999,
                  padding: "4px 8px",
                  fontSize: 12,
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  background: "#fef3c7",
                  color: "#92400e",
                }}>
                  Pendente
                </span>
              </div>
              <div role="radiogroup" aria-label={`Resposta de ${guest.nome}`} style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(88px, 1fr))",
                gap: 8,
                minWidth: 196,
              }}>
                {renderMockAnswer("Vai", "✓", index === 0 ? "yes" : null)}
                {renderMockAnswer("Não vai", "×", index === 1 ? "no" : null)}
              </div>
            </div>
          ))}
        </div>

        <div style={{
          background: messageTheme.sectionBg ?? tema.recadoBg,
          borderRadius: 15,
          padding: 20,
          marginBottom: 20,
          color: messageTheme.textColor ?? tema.sectionTitleColor ?? tema.labelColor,
          fontFamily: messageTheme.fontFamily ?? undefined,
        }}>
          <label style={{
            ...label,
            color: messageTheme.titleColor ?? tema.sectionTitleColor ?? tema.labelColor,
            fontFamily: messageTheme.fontFamily ?? undefined,
          }}>💌 Recado (opcional):</label>
          <textarea
            className="rsvp-themed-field rsvp-message-field"
            placeholder="Deixe um recado carinhoso..."
            rows={3}
            readOnly
            style={{ ...input, ...tema.inputExtra, ...messageTheme.input, resize: "vertical", minHeight: 80 }}
          />
        </div>

        <button type="button" disabled style={{
          padding: "16px 30px",
          border: "none",
          borderRadius: 25,
          cursor: "default",
          fontSize: 17,
          fontWeight: 600,
          width: "100%",
          textTransform: "uppercase",
          letterSpacing: 1,
          ...tema.submit,
        }}>
          Registrar Respostas
        </button>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif", ...getRsvpCssVars(tema), color: tema.formTextColor ?? "inherit" }}>
      {/* Seção pessoas */}
      <div style={{
        background: peopleTheme.sectionBg ?? tema.sectionBg,
        borderRadius: 15,
        padding: 20,
        marginBottom: 20,
        color: peopleTheme.textColor ?? tema.labelColor,
        fontFamily: peopleTheme.fontFamily ?? undefined,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <span style={{
            ...tema.titulo,
            color: peopleTheme.titleColor ?? tema.titulo?.color,
            fontFamily: peopleTheme.fontFamily ?? tema.titulo?.fontFamily,
            fontWeight: 600,
            fontSize: "1.1em",
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            lineHeight: 1.2,
          }}>
            <span style={{ display: "inline-flex", alignItems: "center", lineHeight: 1 }} aria-hidden="true">👥</span>
            <span>Confirmar Pessoas</span>
          </span>
          <span style={{
            padding: "8px 16px",
            borderRadius: 20,
            fontWeight: 600,
            fontSize: 14,
            ...tema.btnAdd,
            ...peopleTheme.addButton,
          }}>
            + Adicionar
          </span>
        </div>

        <div style={{ background: peopleTheme.itemBg ?? tema.itemBg, borderRadius: 12, padding: 20, boxShadow: "0 3px 10px rgba(0,0,0,0.1)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
            <div style={{
              background: peopleTheme.numberBg ?? tema.numeroBg,
              color: peopleTheme.numberColor ?? tema.numeroColor,
              width: 30, height: 30, borderRadius: "50%",
              display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, fontSize: 14,
            }}>
              1
            </div>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 15 }}>
            <div style={{ flex: "2 1 160px", minWidth: 0, marginBottom: 12 }}>
              <label style={{ ...label, color: peopleTheme.textColor ?? tema.labelColor }}>👤 Nome</label>
              <input className="rsvp-themed-field rsvp-people-field" type="text" placeholder="Nome completo" style={{ ...input, ...tema.inputExtra, ...peopleTheme.input }} readOnly />
            </div>
            <div style={{ flex: "1 1 100px", minWidth: 0, marginBottom: 12 }}>
              <label style={{ ...label, color: peopleTheme.textColor ?? tema.labelColor }}>👶 É Criança</label>
              <select className="rsvp-themed-field rsvp-people-field" style={{ ...input, ...tema.inputExtra, ...peopleTheme.input }} defaultValue="nao" disabled>
                <option value="nao">Não</option>
                <option value="sim">Sim</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Seção recado */}
      <div style={{
        background: messageTheme.sectionBg ?? tema.recadoBg,
        borderRadius: 15,
        padding: 20,
        marginBottom: 20,
        color: messageTheme.textColor ?? tema.sectionTitleColor ?? tema.labelColor,
        fontFamily: messageTheme.fontFamily ?? undefined,
      }}>
        <label style={{
          ...label,
          color: messageTheme.titleColor ?? tema.sectionTitleColor ?? tema.labelColor,
          fontFamily: messageTheme.fontFamily ?? undefined,
        }}>💌 Recado (opcional):</label>
        <textarea
          className="rsvp-themed-field rsvp-message-field"
          placeholder="Deixe um recado carinhoso..."
          rows={3}
          readOnly
          style={{ ...input, ...tema.inputExtra, ...messageTheme.input, resize: "vertical", minHeight: 80 }}
        />
      </div>

      <button type="button" disabled style={{
        padding: "16px 30px",
        border: "none",
        borderRadius: 25,
        cursor: "default",
        fontSize: 17,
        fontWeight: 600,
        width: "100%",
        textTransform: "uppercase",
        letterSpacing: 1,
        ...tema.submit,
      }}>
        Confirmar Todas as Presenças
      </button>
    </div>
  );
}

function mockShortcutButton(background, color) {
  return {
    border: "1px solid rgba(148,163,184,0.32)",
    borderRadius: 999,
    padding: "8px 12px",
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 800,
    cursor: "default",
    boxShadow: "0 3px 10px rgba(15,23,42,0.08)",
    fontFamily: "inherit",
    whiteSpace: "nowrap",
    background,
    color,
  };
}

function renderMockAnswer(labelText, symbol, selected) {
  const isYes = selected === "yes";
  const isNo = selected === "no";
  const selectedOption = isYes
    ? { background: "#ecfdf5", borderColor: "#34d399", color: "#047857", boxShadow: "0 7px 18px rgba(16,185,129,0.16)" }
    : isNo
      ? { background: "#fff1f2", borderColor: "#fb7185", color: "#be123c", boxShadow: "0 7px 18px rgba(244,63,94,0.14)" }
      : {};
  const selectedIcon = isYes
    ? { background: "#16a34a", borderColor: "#16a34a", color: "white" }
    : isNo
      ? { background: "#e11d48", borderColor: "#e11d48", color: "white" }
      : {};

  return (
    <label style={{
      minHeight: 42,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 7,
      border: "1px solid rgba(148,163,184,0.36)",
      borderRadius: 12,
      padding: "8px 10px",
      background: "rgba(255,255,255,0.72)",
      color: "#475569",
      fontWeight: 800,
      fontSize: 13,
      userSelect: "none",
      ...selectedOption,
    }}>
      <input
        type="radio"
        checked={!!selected}
        readOnly
        style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}
      />
      <span style={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid rgba(148,163,184,0.45)",
        background: "rgba(255,255,255,0.9)",
        color: "#94a3b8",
        fontSize: 15,
        fontWeight: 900,
        lineHeight: 1,
        ...selectedIcon,
      }}>
        {symbol}
      </span>
      <span style={{ whiteSpace: "nowrap" }}>{labelText}</span>
    </label>
  );
}
